<template>
    <div 
        v-show="timer_visible"
        id="auto-update-panel" 
    >
        <QpeTooltip
            tooltip_position="top"
        >
            <template #hovered_item>
                <v-icon
                    :color="is_activate_auto_update ? '#2cfde1' : '#b3b7c4'"
                    @click="toggle_auto_update_icon"
                >
                    icon-autorenew-start
                </v-icon>
            </template>
            <template #tooltip_content>
                <span>{{ $t('__auto_update_panel.tooltip') }}</span>
            </template>
        </QpeTooltip>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapGetters } from 'vuex';

    export default {
        name: 'AutoUpdatePanel',

        components: {
            QpeTooltip: () => import('@/components/tool/qpe_tooltip.vue'),
        },
        
        data() {
            return {
                is_activate_auto_update: true,
            }
        },

        computed: {
            ...mapState([
                'client_name',
            ]),

            ...mapState('emap', [
                'user_auto_update_setting',
                'current_time_epoch'
            ]),

            ...mapGetters('emap', [
                'timer_visible'
            ])
        },

        watch: {
            is_activate_auto_update() {
                // 打開自動更新時，立刻更新一次

                this.set_user_auto_update_setting(this.is_activate_auto_update);
                this.set_timer_on(this.is_activate_auto_update);
            },

            timer_visible: {
                immediate: true,
                handler() {
                    // 顯示時根據 switch 動作
                    // 隱藏時關閉自動更新
                    if (this.timer_visible) {
                        this.is_activate_auto_update = this.user_auto_update_setting;
                        this.set_timer_on(this.is_activate_auto_update);
                    } else {
                        this.set_timer_on(false);
                    }
                }
            },
        },

        beforeDestroy() {
            this.set_timer_on(false);
        },

        methods: {
            ...mapMutations('emap', [
                'set_timer_on',
                'set_user_auto_update_setting',
            ]),

            toggle_auto_update_icon() {
                this.is_activate_auto_update = !this.is_activate_auto_update
            },
        },
    }
</script>
